import { render } from "./ProductCard.vue?vue&type=template&id=0c65c06c&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=0c65c06c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c65c06c"

export default script